import React, { useEffect, useCallback, useState} from 'react';
import {lstorage} from 'utils/lstorage.js';
import ipfs from 'decentralized/Ipfs.js';
import {publishBulk} from 'decentralized/lists/ExploreLists.js';
import {setExploreUnpublished} from 'actions/index.js';
import {connect} from 'react-redux';

const Publish = ({setExploreUnpublished, unpublished}) => { 

    useEffect(() => {
        let _unpublished = lstorage.getItem("unsavedLists");
        if (!_unpublished) {
            return;
        }
        setExploreUnpublished(JSON.parse(_unpublished));
    }, []);

    const publishChanges = useCallback(async () => {
        let newContents = [];
        let oldContents = [];
        let titles = [];
        let guildIds = [];
        for (let change of unpublished) {
            let hash = await ipfs.addJson(change);
            let oldHash = change.hash;
            change.hash = hash;
            change.newContent = hash;
            newContents.push(hash);
            oldContents.push(oldHash);
            titles.push(change.name);
            guildIds.push(0);
        }
        lstorage.setItem("publishingLists", JSON.stringify(unpublished));
        lstorage.removeItem("unsavedLists");
        publishBulk(newContents, oldContents, titles, guildIds);
        setExploreUnpublished(undefined);
    }, [unpublished]);

    if (!unpublished || unpublished.length === 0) {
        return (<div></div>);
    }

    return (
        <div
          onClick={publishChanges}
          className="save-unpublished-btn">
          Publish Changes <span className="unpublished-count">{unpublished.length}</span>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      unpublished: state.explore.unpublished
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setExploreUnpublished: (x) => dispatch(setExploreUnpublished(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Publish);
